import {
  GetCollaboratorsCmSheetFinalInterviewResponse,
  UpdateCollaboratorsCmSheetFinalInterviewRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetFinalInterviewService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorsCmSheetFinalInterviewResponse> {
    const response =
      await httpClient.get<GetCollaboratorsCmSheetFinalInterviewResponse>(
        `v1/cm-sheets/${cmSheetId}/final-interview`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorsCmSheetFinalInterviewRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/final-interview`, body);
  },
};

export default CmSheetFinalInterviewService;
